import { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { Field, Select } from "../bits";

const ICONS = [["home", "Home"], ["car", "Car"], ["plane", "Travel"], ["graduation", "Education"], ["heart", "Family"], ["briefcase", "Business"], ["target", "Other"]];

export function GoalDialog({ open, onClose, onDone, goal }) {
  const [f, setF] = useState({ name: "", target_amount: "", current_amount: 0, target_date: "", icon: "target" });
  const [busy, setBusy] = useState(false);
  useEffect(() => { setF(goal ? { name: goal.name, target_amount: goal.target_amount, current_amount: goal.current_amount, target_date: goal.target_date || "", icon: goal.icon } : { name: "", target_amount: "", current_amount: 0, target_date: "", icon: "target" }); }, [goal, open]);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      const body = { ...f, target_amount: Number(f.target_amount), current_amount: Number(f.current_amount), target_date: f.target_date || null };
      if (goal) await api.patch(`/goals/${goal.id}`, body); else await api.post("/goals", body);
      toast.success(goal ? "Goal updated" : "Goal created"); onDone?.(); onClose();
    } catch (e2) { toast.error(errMsg(e2)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md rounded-[22px]" data-testid="goal-dialog">
        <DialogHeader><DialogTitle className="text-nini-heading">{goal ? "Edit goal" : "New savings goal"}</DialogTitle><DialogDescription>Personal goals help you track what you're saving towards.</DialogDescription></DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <Field label="Goal name" required><input data-testid="goal-name-input" className="field" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} placeholder="Buy a home" required /></Field>
          <div className="grid grid-cols-2 gap-4">
            <Field label="Target amount" required><input data-testid="goal-target-input" type="number" min="1" className="field" value={f.target_amount} onChange={(e) => setF({ ...f, target_amount: e.target.value })} required /></Field>
            <Field label="Saved so far"><input data-testid="goal-current-input" type="number" min="0" className="field" value={f.current_amount} onChange={(e) => setF({ ...f, current_amount: e.target.value })} /></Field>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <Field label="Target date"><input data-testid="goal-date-input" type="date" className="field" value={f.target_date} onChange={(e) => setF({ ...f, target_date: e.target.value })} /></Field>
            <Field label="Category"><Select testId="goal-icon-select" value={f.icon} onChange={(v) => setF({ ...f, icon: v })} options={ICONS} /></Field>
          </div>
          <button className="btn-primary w-full" data-testid="goal-submit-btn" disabled={busy}>{goal ? "Save changes" : "Create goal"}</button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
